import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'

import {classes, st} from './EmptyState.st.css'

export const EmptyState = () => {
  const {t} = useTranslation()
  return (
    <div className={st(classes.emptyState)}>
      <Text>{t('uou-reservations.experiences-list.empty-state')}</Text>
    </div>
  )
}
